<template>
    <el-dialog ref="formDesignDialog" class="form-design-dialog" :class="[page.dialog.view.replace('Dialog',''), this.page.dialog.view === 'formAttrDialog' && 'form-design-draggable-dialog']" :visible.sync="page.dialog.visible" :title="page.dialog.title" :width="dialogWidth" :close-on-click-modal="false" append-to-body center :modal="page.dialog.view !== 'formAttrDialog'">
        <template v-if="page.dialog.view === 'changeButtonsDialog'">
          <div class="modal-body change-button-dialog-body" ref="changeButtonDialog">
            <transition-group name="transition" tag="ul">
              <template v-for="(button,index) in buttons">
                <el-form class="form-design-border" :model="button" :rules="buttonRules" :inline="true" label-width="70px" :key='button.id'>
                  <p class="form-title">按钮{{buttons.length - index}}</p>
                  <i class="el-icon-close" @click="buttonDelete(index)"></i>
                  <el-form-item label="按钮名称">
                    <el-input v-model="button.name"></el-input>
                  </el-form-item>
                  <el-form-item label="操作类型">
                    <el-select v-model="button.type">
                      <el-option label="确定" value="comfirm"></el-option>
                      <el-option label="取消" value="cancel"></el-option>
                      <el-option label="自定义" value="custom"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-switch v-model="button.tipsEnable" inactive-text="操作提醒">
                  </el-switch>
                  <el-form-item prop="tip">
                    <el-input class="operation-tips" v-model="button.tip" v-show="button.tipsEnable" maxlength="21"></el-input>
                  </el-form-item>
                </el-form>
              </template>
            </transition-group>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button class="add-button" @click="addButton" type="text" icon="el-icon-plus">添加按钮</el-button>
            <el-button type="primary" @click="saveButtons">保存</el-button>
            <el-button @click="cancelButtons">取消</el-button>
          </div>
        </template>
        <template v-if="page.dialog.view === 'changeNameDialog'">
          <div class="modal-body">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item label="表单名称" class="process-name">
                <el-input v-focus v-model="page.formName" @keyup.enter.native="saveName" maxlength="50"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveName">保存</el-button>
            <el-button @click="closeDialog">取 消</el-button>
          </div>
        </template>
        <template v-if="page.dialog.view === 'formAttrDialog'">
            <div class="modal-body">
              <el-form label-position="left" label-width="85px">
                <attr-archived-table-attr
                  ref="attrArchivedTableAttr"
                  :component="page.formAttr"
                  :componentInteraction="page.componentInteraction"
                  :formValidates="page.formValidates"
                  :interactions='page.interactions'
                  :parentDom="parentDom">
                </attr-archived-table-attr>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="saveFormAttr">保存</el-button>
              <el-button @click="closeDialog">取消</el-button>
            </div>
        </template>
        <template v-if="page.dialog.view === 'changeProcessNameDialog'">
          <div class="modal-body">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item label="流程名称" class="process-name">
                <el-input v-focus v-model="page.processName" @change="changeProcessName"  @keyup.enter.native="saveProcessName" maxlength=50></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveProcessName">保存</el-button>
            <el-button @click="closeDialog">取消</el-button>
          </div>
        </template>
        <template v-if="page.dialog.view === 'changeReportNameDialog'">
          <div class="modal-body">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item label="报表名称" class="process-name">
              <el-input v-focus v-model="page.reportName" @change="changeReportName" @keyup.enter.native="saveReportName" maxlength=50></el-input>
            </el-form-item>
          </el-form>
        </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveReportName">保存</el-button>
            <el-button @click="closeDialog">取消</el-button>
          </div>
      </template>
      </el-dialog>
</template>
<script>
import AttrArchivedTableAttr from '../componentAttr/archived-table-attr'
import Button from '../../../store/report/button'
export default {
  name: 'FormDesignDialog',
  props: ['page', 'formId'],
  inject: ['formService'],
  components: {
    AttrArchivedTableAttr
  },
  data () {
    let validateTips = (rule, value, callback) => {
      if (value.length > 20) {
        callback(new Error('最长为20个字符'))
      } else {
        callback()
      }
    }
    return {
      buttons: this.page.buttons && this.$_.cloneDeep(this.page.buttons).reverse(), // 加载时将按钮顺序倒序展示
      buttonRules: {
        tip: [{validator: validateTips, trigger: 'change'}]
      },
      parentDom: null
    }
  },
  methods: {
    openDialog (view, title) {
      this.page.dialog = {
        visible: true,
        view,
        title
      }
    },
    changeProcessName (val) {
      this.page.processName = val
    },
    checkDefinitionName () {
      return this.$axios.get(`/process-api/processes/${this.page.id}/validateProcessName`, {params: { 'name': this.page.processName }})
        .then(res => res.data)
    },
    saveProcessName () {
      if (!this.page.processName) {
        this.$message.info('请填写流程名称')
        return
      }
      // 名称重复性
      this.checkDefinitionName().then((res) => {
        if (res) {
          // true 是名称可用
          this.closeDialog()

          this.$emit('finishCheckDefinition', this.page.processName)
        } else {
          this.$message.info('该流程名称已存在，请更换流程名称')
        }
      })
    },
    checkFormName () {
      return this.$axios.get(`/form-api/defines/${this.page.defineId}/validateName?name=${this.page.formName}`)
    },
    saveName () {
      if (!this.page.formName) {
        this.$message.info('请填写表单名称')
        return
      }
      this.checkFormName().then((res) => {
        if (res) {
          this.$emit('setDefinitionName', { name: this.page.formName, isPublish: this.page.dialog.isPublish, isSave: this.page.dialog.isSave })
          this.closeDialog()
        } else {
          this.$message.info('该表单名称已存在，请更换表单名称')
        }
      })
    },
    // 添加按钮
    addButton () {
      let button = new Button({name: '自定义', type: 'custom'})
      this.buttons.unshift(button)
      this.$refs.changeButtonDialog.scrollTop = 0
    },
    // 删除按钮
    buttonDelete (index) {
      this.$confirm('', '你确定要删除吗?', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        customClass: 'deleMessageBox',
        center: true
      }).then(() => {
        this.buttons.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功'
        })
      })
    },
    saveButtons () {
      // 保存时真实按钮顺序应该反过来
      this.buttons.reverse().forEach(item => {
        if (item.tipsEnable === false) {
          item.tip = ''
        }
      })
      this.$emit('setDefinitionButtons', this.buttons)
      this.closeDialog()
    },
    saveFormAttr () {
      // 这个地方指向原来的子控件的内容, 防止指向发生改变
      this.page.formAttr.children = this.formService.component.children
      this.formService.updateAttr(this.page.formAttr)
      // 修改归档时如果表单没有名字就把归档表的名字赋值
      if (this.page.formName === '' && this.page.formAttr.name) {
        this.page.formName = this.page.formAttr.name
        this.$emit('setDefinitionName', {name: this.page.formName})
      }

      // 校验通过才对数据处理
      Promise.all(this.$refs.attrArchivedTableAttr.verificationSubmit())
        .then(() => Promise.all(this.$refs.attrArchivedTableAttr.componentInteractionsSubmit()))
        .then(() => Promise.all(this.$refs.attrArchivedTableAttr.interactionSubmit()))
        .then(() => {
          this.closeDialog()
          // 控件交互数据处理
          this.page.componentInteraction.reverse() // 存的时候顺序取反
          this.page.interactions.reverse()
          this.page.formValidates.reverse()
          this.page.componentInteraction.forEach(m => {
            // 控件交互每项本来无id, 为了vue区分手动加了, 保存时删除.
            m.id && delete m.id
            m.conforms.forEach(n => {
              if (n.changeComponent) { n.changeComponent = n.changeComponent.join(',') }
            })
            m.noConforms.forEach(n => {
              if (n.changeComponent) { n.changeComponent = n.changeComponent.join(',') }
            })
          })
          this.formService.component.properties.componentInteraction = this.page.componentInteraction
          // 校验数据联动
          this.page.interactions.forEach(m => {
            m.formId = this.formId
            m.type = m.type.join(',')
          })
          this.formService.component.interactions = this.page.interactions

          // 操作校验
          this.page.formValidates.forEach(m => {
            m.operationType = m.operationType.join(',')
          })
          this.formService.component.formValidates = this.page.formValidates
        }).catch((err) => {
          console.log(err)
        })
    },
    cancelButtons () {
      this.$emit('setDefinitionButtons', this.page.buttons)
      this.closeDialog()
    },
    closeDialog () {
      this.page.dialog.visible = false
    },
    // 表单
    changeReportName (val) {
      this.page.reportName = val
    },
    saveReportName () {
      if (!this.page.reportName) {
        this.$message.info('请填写报表名称')
        return
      }
      // 缺少重复性校验
      this.$axios.get(`/report-api/report/definition/haveRepeatName/${this.page.reportId}`, {params: {name: this.page.reportName, dataSourceReport: this.page.dataSourceReport}}).then(({data}) => {
        if (data.haveRepeatName) {
          this.$message.info('该报表名称已存在，请更换报表名称')
        } else {
          this.$emit('setDefinitionName', { name: this.page.reportName, isPublish: this.page.dialog.isPublish })
          this.closeDialog()
        }
      })
    }
  },
  computed: {
    dialogWidth () {
      let width = ''
      switch (this.page.dialog.view) {
        case 'formAttrDialog':
          width = '540px'
          break
        case 'changeButtonsDialog':
          width = '600px'
          break
        default:
          width = '400px'
      }
      return width
    }
  },
  mounted () {
    if (this.$refs.formDesignDialog && this.$refs.formDesignDialog.$el && this.$refs.formDesignDialog.$el.childNodes) {
      this.parentDom = this.$refs.formDesignDialog.$el.childNodes[0]
    }
  },
  watch: {
    'page.dialog.visible' (val) {
      if (!val) {
        // 每次关闭的时候需要把清空事件
        this.page.dialog.view === 'formAttrDialog' && this.parentDom && this.parentDom.removeEventListener('mousedown', () => {})
      }
    }
  }
}

</script>
<style lang="scss">
.form-design-dialog {
  .el-dialog--center .el-dialog__body {
    padding: 30px 26px 5px 26px;
    overflow: auto;

    .change-button-dialog-body {
      height: 380px;
      overflow: auto;
      p {
        width: 45px;
        position: relative;
        top: -15px;
        text-align: center;
        color: #409EFF;
        background-color: #ffffff;
      }

      .el-icon-close {
        display: block;
        float: right;
        position: relative;
        top: -30px;
        left: -10px;
        background-color: #ffffff;

        &:hover {
          color: #ff0000;
        }
      }

      .form-design-border {
        border: 1px solid #ebebeb;
        padding: 5px 0 10px 18px;
        margin-top: 14px;
        margin-bottom: 4px;
        height: 120px;

        .el-form-item {
          margin-bottom: 20px;

          .el-input {
            width: 166px;
          }

          .operation-tips {
            width: 360px;
          }

          .el-form-item__label {
            text-align: left;
          }
        }

        .el-switch {
          height: 28px;
          margin-right: 20px;
        }

        .el-switch__label {
          height: 28px;
          line-height: 28px;
          color: #606266;
        }
      }
    }

    .process-name {
      width: 100%;

      .el-form-item__content {
        width: 70%;
      }
    }

  }

  .el-button {
    padding: 8px 35px;
  }

  .add-button {
    width: 40%;
    height: 45px;
    padding: 0 0 10px;
    margin: 0 30% 10px;
  }
  /*控件交互,数据联动,操作校验的动画效果样式*/
  .transition-enter{
    transform: translateY(-150px);
  }
  .transition-leave-to{
    opacity: 0;
  }
  .transition-enter-active, .transition-leave-active{
    transition: all .3s ease-out;
  }
  .transition-leave-active{
    position: absolute;
  }
  .transition-move {
    transition: transform .3s;
  }
}

.el-message.message-form-save {

  .el-icon-success,
  .el-message__content {
    color: #409EFF;
  }

  &.el-message--success {
    background-color: transparent;
    border-color: transparent;
  }

}

.form-design-draggable-dialog.el-dialog__wrapper {
  overflow: hidden !important;
  .el-dialog {
    position: absolute;
    // 修改style属性
    margin: 0!important;
    padding: 0;
    left: calc(50% - 270px);
    top: calc(50% - 271px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/design/form-design-dialog.vue